export default "__VITE_ASSET__b2SUGOlC__"